import { ISlugify } from '../../../widget/app/services/filters/slugify/slugify.filter';
import { encodeName } from '../../utils/encodeName';

export type IBitUrlBuilder = ReturnType<typeof bitUrlBuilderFactory>;

/* @ngInject */
export function bitUrlBuilderFactory(slugifyFilter: ISlugify) {
  const API_URL = 'https://rest.bandsintown.com/artists';

  return {
    buildEventUrl(artistName) {
      const encodedName = encodeName(artistName);
      const referer = encodeName(`WIX_${slugifyFilter(artistName)}`);
      return `${API_URL}/${encodedName}/events?app_id=${referer}`;
    },
    buildArtistUrl(artistName) {
      const encodedName = encodeName(artistName);
      const referer = encodeName(`WIX_${slugifyFilter(artistName)}`);
      return `${API_URL}/${encodedName}?app_id=${referer}`;
    },
  };
}
